/* PWA: install, updates and web push notifications. Kept apart from uk.ts/en.ts to keep merges small. */
export const pwaUk = {
  'pwa.install': 'Встановити застосунок',
  'pwa.installHint': 'Dovira Pro на головному екрані: відкривається як застосунок і надсилає сповіщення.',
  'pwa.installed': 'Застосунок встановлено',
  'pwa.update': 'Доступна нова версія',
  'pwa.updateAction': 'Оновити',
  'pwa.ios.title': 'Встановити на iPhone або iPad',
  'pwa.ios.lead': 'На iPhone застосунок встановлюється з Safari у три кроки:',
  'pwa.ios.step1': 'Відкрийте цю сторінку в Safari (не в Chrome чи Telegram).',
  'pwa.ios.step2': 'Натисніть «Поділитися» внизу екрана (квадрат зі стрілкою вгору).',
  'pwa.ios.step3': 'Оберіть «На початковий екран» → «Додати».',
  'pwa.ios.push': 'Push-сповіщення на iPhone працюють лише у встановленому застосунку (iOS 16.4 і новіші): відкрийте Dovira з іконки на головному екрані і ввімкніть сповіщення в «Профіль → Сповіщення».',
  'push.title': 'Push-сповіщення',
  'push.text': 'Сповіщення на цьому пристрої, навіть коли Dovira закрита. Telegram і пошта працюють як раніше — push додається до них.',
  'push.enable': 'Увімкнути сповіщення',
  'push.enableHere': 'Увімкнути на цьому пристрої',
  'push.disableHere': 'Вимкнути на цьому пристрої',
  'push.enabled': 'Сповіщення ввімкнено на цьому пристрої',
  'push.thisDevice': 'Цей пристрій',
  'push.test': 'Тестове сповіщення',
  'push.testSent': 'Надіслано на {n} пристр.',
  'push.testNone': 'Немає підписаних пристроїв',
  'push.devices': 'Мої пристрої',
  'push.noDevices': 'Сповіщення ще не ввімкнено на жодному пристрої.',
  'push.remove': 'Вимкнути',
  'push.lastOk': 'Остання доставка {when}',
  'push.never': 'ще не доставлялось',
  'push.failures': 'Помилок поспіль: {n}',
  'push.installedBadge': 'застосунок',
  'push.channel': 'Надсилати push-сповіщення',
  'push.channelHint': 'Вимкніть, щоб тимчасово зупинити push на всіх пристроях (підписки збережуться).',
  'push.kinds': 'Які сповіщення надсилати',
  'push.kindsHint': 'Вимкнені види не надходять як push, але лишаються в дзвіночку і в Telegram.',
  'push.denied': 'Сповіщення заборонені в налаштуваннях браузера для цього сайту. Дозвольте їх (значок замка в адресному рядку → Сповіщення) і спробуйте ще раз.',
  'push.dismissed': 'Дозвіл не надано. Натисніть ще раз і оберіть «Дозволити».',
  'push.unsupported': 'Цей браузер не підтримує push-сповіщення. Спробуйте Chrome, Edge, Firefox або Safari.',
  'push.iosInstall': 'На iPhone і iPad push працює лише у встановленому застосунку. Спершу встановіть Dovira на головний екран, відкрийте її з іконки — і ввімкніть тут.',
  'push.iosOld': 'Потрібна iOS 16.4 або новіша. Оновіть iPhone, щоб отримувати push-сповіщення.',
  'push.off': 'Web push вимкнено адміністратором.',
  'push.failed': 'Не вдалося ввімкнути сповіщення. Спробуйте ще раз.',
  'push.saved': 'Збережено',
  'push.group.tasks': 'Задачі',
  'push.group.process': 'Чеклісти',
  'push.group.clinic': 'Клініка',
  'push.group.alerts': 'Інциденти і тривоги',
  'push.group.desk': 'Рецепція і кол-центр',
  'push.group.money': 'Гроші',
  'push.group.people': 'Персонал і документи',
  'push.group.stock': 'Склад',
  'push.group.system': 'Система',
  'push.kind.task_assigned': 'Нове завдання',
  'push.kind.task_comment': 'Коментар до завдання',
  'push.kind.task_due': 'Строк завдання',
  'push.kind.checklist_due': 'Чекліст до виконання',
  'push.kind.checklist_overdue': 'Прострочений чекліст',
  'push.kind.checklist_attention': 'Чекліст потребує уваги',
  'push.kind.ward_check_overdue': 'ВРІТ: прострочений огляд',
  'push.kind.ward_report_due': 'ВРІТ: звіт власнику',
  'push.kind.ward_handover': 'ВРІТ: передача зміни',
  'push.kind.ai_draft_ready': 'Чернетка асистента готова',
  'push.kind.shipment_overdue': 'Лабораторія: прострочена відправка',
  'push.kind.shipment_result': 'Лабораторія: результат',
  'push.kind.blood_unit_expiry': 'Банк крові: строк придатності',
  'push.kind.control_calls_due': 'Контрольні дзвінки',
  'push.kind.clinq_digest': 'Якість карток: дайджест',
  'push.kind.incident_new': 'Новий інцидент',
  'push.kind.incident_sla': 'Інцидент: строк реакції',
  'push.kind.incident_update': 'Інцидент: оновлення',
  'push.kind.code_alert': '«Код червоний / жовтий»',
  'push.kind.low_rating_alert': 'Низька оцінка клієнта',
  'push.kind.inquiry_sla': 'Звернення: SLA',
  'push.kind.inquiry_handover': 'Передача зміни кол-центру',
  'push.kind.waitlist_slot': 'Лист очікування: є вікно',
  'push.kind.consent_answered': 'Клієнт підписав згоду',
  'push.kind.cash_alert': 'Каса: тривога',
  'push.kind.night_payment': 'Нічні оплати',
  'push.kind.discount_request': 'Запит на знижку',
  'push.kind.fop_limit': 'Ліміт ФОП',
  'push.kind.loan_due': 'Строк позики',
  'push.kind.fincontrol_finding': 'Фінконтроль',
  'push.kind.invoice_payment_due': 'Накладна: строк оплати',
  'push.kind.invoice_discrepancy': 'Накладна: розбіжність',
  'push.kind.kb_ack_request': 'База знань: ознайомитися',
  'push.kind.kb_review_due': 'База знань: перегляд',
  'push.kind.briefing_due': 'Інструктаж',
  'push.kind.certificate_expiry': 'Строк сертифіката',
  'push.kind.register_expiry': 'Реєстри: строки',
  'push.kind.content_deadline': 'Контент: дедлайн',
  'push.kind.content_review': 'Контент: рецензія',
  'push.kind.stock_expiry': 'Склад: строк придатності',
  'push.kind.stock_to_order': 'Склад: замовити',
  'push.kind.stock_count_differences': 'Склад: розбіжності інвентаризації',
  'push.kind.sync_alert': 'Синхронізація: збій',
  'push.kind.insight_published': 'Нові інсайти',
  'pushHealth.title': 'Push-сповіщення (PWA)',
  'pushHealth.keys': 'Ключі VAPID',
  'pushHealth.keysOk': 'готові ({source}, {id})',
  'pushHealth.keysOff': 'ще не створені або вимкнені',
  'pushHealth.staff': 'Співробітники з push',
  'pushHealth.staffSub': '{n} з {m} активних · {d} пристр.',
  'pushHealth.clients': 'Клієнти з push',
  'pushHealth.clientsSub': '{d} пристр. · встановили застосунок: {i}',
  'pushHealth.rate': 'Доставлено за 7 днів',
  'pushHealth.rateSub': '{sent} доставлено · {failed} помилок · {revoked} підписок знято',
  'pushHealth.failures': 'Останні помилки',
  'pushHealth.noFailures': 'Помилок за тиждень немає.',
  'pushHealth.subject.user': 'співробітник',
  'pushHealth.subject.client': 'клієнт',
}

export const pwaEn: Record<keyof typeof pwaUk, string> = {
  'pwa.install': 'Install app',
  'pwa.installHint': 'Dovira Pro on your home screen: opens like an app and sends notifications.',
  'pwa.installed': 'App installed',
  'pwa.update': 'A new version is available',
  'pwa.updateAction': 'Update',
  'pwa.ios.title': 'Install on iPhone or iPad',
  'pwa.ios.lead': 'On iPhone the app is installed from Safari in three steps:',
  'pwa.ios.step1': 'Open this page in Safari (not Chrome or Telegram).',
  'pwa.ios.step2': 'Tap “Share” at the bottom of the screen (a square with an up arrow).',
  'pwa.ios.step3': 'Choose “Add to Home Screen” → “Add”.',
  'pwa.ios.push': 'On iPhone push notifications work only in the installed app (iOS 16.4 and later): open Dovira from the home screen icon and enable notifications in Profile → Notifications.',
  'push.title': 'Push notifications',
  'push.text': 'Notifications on this device, even when Dovira is closed. Telegram and e-mail keep working — push is added to them.',
  'push.enable': 'Enable notifications',
  'push.enableHere': 'Enable on this device',
  'push.disableHere': 'Disable on this device',
  'push.enabled': 'Notifications are enabled on this device',
  'push.thisDevice': 'This device',
  'push.test': 'Test notification',
  'push.testSent': 'Sent to {n} device(s)',
  'push.testNone': 'No subscribed devices',
  'push.devices': 'My devices',
  'push.noDevices': 'Notifications are not enabled on any device yet.',
  'push.remove': 'Disable',
  'push.lastOk': 'Last delivered {when}',
  'push.never': 'not delivered yet',
  'push.failures': 'Failures in a row: {n}',
  'push.installedBadge': 'app',
  'push.channel': 'Send push notifications',
  'push.channelHint': 'Turn off to pause push on all devices (subscriptions are kept).',
  'push.kinds': 'Which notifications to push',
  'push.kindsHint': 'Muted kinds are not pushed but stay in the bell and in Telegram.',
  'push.denied': 'Notifications are blocked for this site in the browser settings. Allow them (lock icon in the address bar → Notifications) and try again.',
  'push.dismissed': 'Permission was not granted. Click again and choose “Allow”.',
  'push.unsupported': 'This browser does not support push notifications. Try Chrome, Edge, Firefox or Safari.',
  'push.iosInstall': 'On iPhone and iPad push works only in the installed app. Install Dovira to the home screen first, open it from the icon and enable it here.',
  'push.iosOld': 'iOS 16.4 or later is required. Update the iPhone to receive push notifications.',
  'push.off': 'Web push is turned off by the administrator.',
  'push.failed': 'Could not enable notifications. Please try again.',
  'push.saved': 'Saved',
  'push.group.tasks': 'Tasks',
  'push.group.process': 'Checklists',
  'push.group.clinic': 'Clinic',
  'push.group.alerts': 'Incidents and alerts',
  'push.group.desk': 'Front desk and call centre',
  'push.group.money': 'Money',
  'push.group.people': 'People and documents',
  'push.group.stock': 'Stock',
  'push.group.system': 'System',
  'push.kind.task_assigned': 'New task',
  'push.kind.task_comment': 'Task comment',
  'push.kind.task_due': 'Task due',
  'push.kind.checklist_due': 'Checklist due',
  'push.kind.checklist_overdue': 'Checklist overdue',
  'push.kind.checklist_attention': 'Checklist needs attention',
  'push.kind.ward_check_overdue': 'ICU: check overdue',
  'push.kind.ward_report_due': 'ICU: owner report',
  'push.kind.ward_handover': 'ICU: handover',
  'push.kind.ai_draft_ready': 'Assistant draft ready',
  'push.kind.shipment_overdue': 'Lab: shipment overdue',
  'push.kind.shipment_result': 'Lab: result',
  'push.kind.blood_unit_expiry': 'Blood bank: expiry',
  'push.kind.control_calls_due': 'Control calls',
  'push.kind.clinq_digest': 'Record quality digest',
  'push.kind.incident_new': 'New incident',
  'push.kind.incident_sla': 'Incident: response deadline',
  'push.kind.incident_update': 'Incident: update',
  'push.kind.code_alert': '“Code red / yellow”',
  'push.kind.low_rating_alert': 'Low client rating',
  'push.kind.inquiry_sla': 'Inquiry SLA',
  'push.kind.inquiry_handover': 'Call-centre handover',
  'push.kind.waitlist_slot': 'Waiting list: slot available',
  'push.kind.consent_answered': 'Client signed a consent',
  'push.kind.cash_alert': 'Cash desk alert',
  'push.kind.night_payment': 'Night payments',
  'push.kind.discount_request': 'Discount request',
  'push.kind.fop_limit': 'FOP limit',
  'push.kind.loan_due': 'Loan due',
  'push.kind.fincontrol_finding': 'Financial control',
  'push.kind.invoice_payment_due': 'Invoice payment due',
  'push.kind.invoice_discrepancy': 'Invoice discrepancy',
  'push.kind.kb_ack_request': 'Knowledge base: acknowledge',
  'push.kind.kb_review_due': 'Knowledge base: review',
  'push.kind.briefing_due': 'Briefing',
  'push.kind.certificate_expiry': 'Certificate expiry',
  'push.kind.register_expiry': 'Registers: deadlines',
  'push.kind.content_deadline': 'Content deadline',
  'push.kind.content_review': 'Content review',
  'push.kind.stock_expiry': 'Stock expiry',
  'push.kind.stock_to_order': 'Stock to order',
  'push.kind.stock_count_differences': 'Stock count differences',
  'push.kind.sync_alert': 'Sync failure',
  'push.kind.insight_published': 'New insights',
  'pushHealth.title': 'Push notifications (PWA)',
  'pushHealth.keys': 'VAPID keys',
  'pushHealth.keysOk': 'ready ({source}, {id})',
  'pushHealth.keysOff': 'not created yet or disabled',
  'pushHealth.staff': 'Staff with push',
  'pushHealth.staffSub': '{n} of {m} active · {d} device(s)',
  'pushHealth.clients': 'Clients with push',
  'pushHealth.clientsSub': '{d} device(s) · installed the app: {i}',
  'pushHealth.rate': 'Delivered in 7 days',
  'pushHealth.rateSub': '{sent} delivered · {failed} failed · {revoked} subscriptions removed',
  'pushHealth.failures': 'Recent failures',
  'pushHealth.noFailures': 'No failures this week.',
  'pushHealth.subject.user': 'staff',
  'pushHealth.subject.client': 'client',
}
